import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Breadcrumbs, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { useParams } from 'react-router';
import { toNullableNumber } from '@/utils/html';
import { SimplePageTitle } from '@/components/layout/PageTitle';
import theme from './ProjectCommentThreadMobile.module.scss';
import { IState } from '@/state/IState';
import { useSelector } from 'react-redux';
import { CommentThreadWrapper } from '../../../components/Comments/CommentThreadWrapper';
import { BreadcrumbsProjectLink } from '@/components/navigation';

interface ProjectCommentThreadMobileProps {
    profileId: number;
}

const ProjectCommentThreadMobile: React.FC<ProjectCommentThreadMobileProps> = ({ profileId }) => {
    const { id: threadId } = useParams<{ id: string | undefined }>();
    const selectedThread = toNullableNumber(threadId || '');

    const project = useSelector((state: IState) => state.global.activeProject);
    const [threadName, setThreadName] = useState('');

    if (!project) {
        return <LoadingIndicator />;
    }

    return (
        <div className={theme.container}>
            <SimplePageTitle title={t`Messages`} />

            <Breadcrumbs>
                <BreadcrumbsProjectLink to="/messages">
                    <Trans>Messages</Trans>
                </BreadcrumbsProjectLink>

                <Breadcrumbs.Item>
                    <span>{threadName}</span>
                </Breadcrumbs.Item>
            </Breadcrumbs>
            <CommentThreadWrapper
                threadId={selectedThread!}
                onThreadLoad={(thread) => setThreadName(thread?.threadName ?? '')}
            />
        </div>
    );
};

export default ProjectCommentThreadMobile;
